import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import { AgreementModalViewerFragmentDoc } from '../components/organisms/AgreementModal/AgreementModal.generated';
import { CreditCardRegistrationModalContractFragmentDoc } from '../features/contract/components/CreditCardRegistrationModal/CreditCardRegistrationModal.generated';
export type ModalManagerViewerFragment = { __typename?: 'Viewer', id: string, requiredAgreementTerms: Array<{ __typename?: 'TermRevision', id: string, type: Types.TermType, title: string, body: MarkdownString }> };

export type ModalManagerContractFragment = { __typename?: 'Contract', contractType: Types.ContractType, paymentMethod: Types.PaymentMethod, isCreditCardAvailable: boolean };

export const ModalManagerViewerFragmentDoc = gql`
    fragment ModalManagerViewer on Viewer {
  ...AgreementModalViewer
}
    ${AgreementModalViewerFragmentDoc}`;
export const ModalManagerContractFragmentDoc = gql`
    fragment ModalManagerContract on Contract {
  ...CreditCardRegistrationModalContract
  contractType
  paymentMethod
}
    ${CreditCardRegistrationModalContractFragmentDoc}`;